import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro.js";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao.js";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2.js";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../../contexts/Cor.js";
import NomeTabelaRedux from "../../../../contexts/NomeTabela.js";
import RequestControllerRedux from "../../../../contexts/RequestController.js";
import TabelaRedux from "../../../../contexts/Tabela.js";
import DadosUsuarioRedux from "../../../../contexts/Usuario.js";
import loadingGif from "../../../../images/loading.gif";
import { getRegras } from "../../../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraTipoObservacao,
	deleteTipoObservacaoPorId,
	editaTipoObservacaoPorId,
	getTipoObservacaoPorId,
	getTipoObservacaoPorProprietarioId
} from "../../../../services/ModuloGerenciador/TipoObservacao.js";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario.js";
import "./TipoObservacao.css";

function TipoObservacao(props) {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const buscarTipoObservacao = async () => {
		setLoading(true);
		await getTipoObservacaoPorProprietarioId(
			props.motoristaId,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (values.observacao !== "" && validator.observacao === "true") {
			setLoading(true);
			await cadastraTipoObservacao(values, dadosUsuarioRedux.token)
				.then((result) => {
					if (result.status === 200) {
						buscarTipoObservacao();
						setDadosRequestControllerRedux("Fechar Modal TipoObservacao");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setValues({});
						setTelaCadastro(false);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaTipoObservacaoPorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoObservacao();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarTipoObservacaoPorId = async () => {
		setLoading(true);
		await getTipoObservacaoPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarTipoObservacaoPorIdModal = async (id) => {
		setLoading(true);
		await getTipoObservacaoPorId(id, dadosUsuarioRedux.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarTipoObservacaoPorId = async () => {
		setLoading(true);
		await deleteTipoObservacaoPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoObservacao();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValues((current) => ({
			...current,
			usuario: dadosUsuarioRedux.usuario.usuario,
		}));
		setValues((current) => ({ ...current, motoristaId: props.motoristaId }));
		setValidator((current) => ({ ...current, observacao: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarTipoObservacaoPorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarTipoObservacao();
		if (props.idAtual) {
			buscarTipoObservacaoPorIdModal(props.idAtual);
		}
	}, []);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element === "Uso Comum") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra === "Uso Comum") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<div className="header-cliente-v2">
										<div className="flex">
											<p className="indicador-principal-embarque-v2">
												Tipo Observação
											</p>
										</div>
									</div>
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="id"
										nomeClasse1="outer-wrapper-cidade"
										nomeClasse2="table-wrapper-cidade-v2"
										colunas={dadosTabelaRedux.TipoObservacao}
										dados={dadosTabela}
									/>
									<div className="container-botoes-tipoObservacao">
										<div>
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Cadastrar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setTelaCadastro(true);
													setEditando(false);
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-deletar"
												classText="button-texto-cadastrar"
												titulo="Deletar"
												icone="iconeDelete"
												cor="#DC2D2D"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setOpen(true);
														setTextoSucesso("Deletado Com Sucesso");
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
										<div>
											<CustomButtonV2
												classCss="custom-button-user"
												classText="button-texto-user"
												titulo="Obter Usuário"
												cor="#FFFFFF"
												valor={values}
												onClick={() => {
													if (tabelaRedux.usuarioAlteracao) {
														setOpenUsuario(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									{!props.desabilitar ? (
										<div className="indicadores">
											<p className="indicador-emb">
												{"Dados de Tipo Observação / "}
											</p>
											{editando ? (
												<p className="indicador-emb">
													{"Detalhes de Tipo Observação"}
												</p>
											) : (
												<p className="indicador-emb">
													{"Cadastro de Tipo Observação"}
												</p>
											)}
										</div>
									) : (
										<></>
									)}
									<div className="flex">
										{!props.botaoVoltar ? (
											<div className="flex-emb">
												{editando ? (
													<HeaderCadastro texto="Detalhes de Tipo Observação" />
												) : (
													<HeaderCadastro texto="Cadastro de Tipo Observação" />
												)}
												<CloseIcon
													onClick={() => {
														setValues({});
														setTelaCadastro(false);
														setEditando(false);
														setTabelaRedux({});
													}}
												/>
											</div>
										) : (
											<></>
										)}
									</div>
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															Observação:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	observacao: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	observacao: "true",
																}));
															}}
															placeholder="Ex: Pallet"
															value={values.observacao}
															disabled={props.desabilitar}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="botoes-tipoObservacao">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
													setTelaCadastro(false);
													setEditando(false);
													setValues({});
												}}
											/>
										) : (
											<>
												{!props.desabilitar ? (
													props.botaoCadastrar ? (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.observacao !== "" &&
																	validator.observacao === "true"
																) {
																	cadastrar();
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													) : (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.observacao !== "" &&
																	validator.observacao === "true"
																) {
																	cadastrar();
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													)
												) : (
													<></>
												)}
											</>
										)}
										{props.botaoVoltar ? (
											<></>
										) : (
											<CustomButtonV2
												classCss="custom-button-cancelar"
												classText="button-texto-cancelar"
												titulo="Cancelar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										)}
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarTipoObservacaoPorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<div
							style={{
								alignItems: "center",
								justifyContent: "center",
								display: "flex",
							}}
						>
							<img
								src={loadingGif}
								alt="Carregando"
								style={{ maxWidth: "20%", maxHeight: "20%" }}
							></img>
						</div>
					)}
				</div>
			)}
		</motion.div>
	);
}

export default TipoObservacao;
